import React from 'react';
import { Route } from 'react-router-dom';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import PlanPeriodUpdate from './form/plan-period-update';
import PlanPeriod from './view/plan-period';

const PlanPeriodRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<PlanPeriod />} />
    <Route path="new" index element={<PlanPeriodUpdate />} />
    <Route path=":id">
      <Route index element={<PlanPeriodUpdate />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default PlanPeriodRoutes;
